import React, { useState } from "react";
import "./App.css";
import GradeTable from "./GradeTable";
import AddCourseForm from "./AddCourseForm";

function App() {
  const [grades, setGrades] = useState([]);

  function addGrade(newGrade) {
    setGrades([...grades, newGrade]);
  }

  return (
    <div className="App">
      <h1 className="topHeader">SGPA Calculator</h1>
      <AddCourseForm addGrade={addGrade} />
      {grades.length > 0 ? (
        <GradeTable grades={grades} setGrades={setGrades} />
      ) : null}
      <footer>copyright &copy; all rights are reserved --Amar</footer>
    </div>
  );
}

export default App;
